import { useState, useEffect } from 'react';
import { useSubscription } from '../../features/subscription/hooks/useSubscription';
import { useImpersonation } from '@shared/hooks/useImpersonation';

export const useSubscriptionStatusPopup = () => {
    const [isOpen, setIsOpen] = useState(false);
    const { currentSubscription } = useSubscription();
    const { canImpersonate } = useImpersonation();

    // A trial that has passed its end date but hasn't yet been flipped server-side
    // (the daily cron does that) should still force plan selection immediately.
    const isTrialExpired = () => {
        if (!currentSubscription) return false;
        if (currentSubscription.status !== 'trialing' || !currentSubscription.trialEndDate) return false;
        return new Date(currentSubscription.trialEndDate) <= new Date();
    };

    const isSubscriptionPausedOrCancelled = () => {
        if (!currentSubscription) return false;

        if (canImpersonate) return false;

        return ['canceled', 'incomplete', 'incomplete_expired', 'paused'].includes(
            currentSubscription.status
        ) || isTrialExpired();
    };

    useEffect(() => {
        // Show popup if subscription is paused/cancelled or the trial has expired
        if (isSubscriptionPausedOrCancelled()) {
            setIsOpen(true);
        }
    }, [currentSubscription]);

    const openPopup = () => setIsOpen(true);
    const closePopup = () => setIsOpen(false);

    return {
        isOpen,
        openPopup,
        closePopup,
        isSubscriptionPausedOrCancelled: isSubscriptionPausedOrCancelled(),
    };
};
